import { ReactComponent as DownloadLogsIcon } from "@common/assets/images/shared-icons/download-icon.svg";
import { NavItem } from "@common/components/Navigation/Navigation.styles";
import { vars } from "@common/styles";
import styled, { css } from "styled-components";

export const NavigationTitle = styled(NavItem)<{ $isButton?: boolean }>`
  p {
    color: ${vars.colors.grey10};
    font-weight: normal;
  }

  div {
    display: flex;
    align-items: center;
    height: 100%;

    p {
      max-width: 19rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      user-select: none;

      padding-left: 0.8rem;
      padding-right: 0.8rem;
      font-weight: normal;
    }

    ${(props) =>
      props.$isButton &&
      css`
        &:hover {
          background-color: ${vars.colors.grey100};
          border-radius: 1rem;
        }
      `}
  }
`;

export const Popover = styled.div`
  position: relative;
  width: 24rem;
  border-radius: 1rem;
  border: 1px solid ${vars.colors.grey90};
  box-shadow: 0 0.2rem 1rem 0 #1c1c1e;
  background-color: ${vars.colors.grey100};
  padding: 1rem 0;
  margin: 0;
  cursor: default;
  z-index: ${vars.zIndex.modalContent};
  &:focus-visible {
    border: 1px solid ${vars.colors.grey90};
    outline: transparent;
  }
`;

export const DownloadIcon = styled(DownloadLogsIcon)`
  margin-left: 1rem;
  cursor: pointer;
  margin-right: 0.2rem;

  ${(props) =>
    props.$disabled &&
    css`
      cursor: not-allowed;
      svg {
        path: ${vars.colors.grey70};
      }
    `}
`;

export const NavbarNavigation = styled.div`
  border-radius: 50%;
  border: 1px solid ${vars.colors.grey80}; /* Grey border */
  background-color: ${vars.colors.grey100};
  margin-right: 1rem;
  width: 3rem !important;
  height: 3rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(180deg);
  cursor: pointer;
`;
